export const onlyAlphabets = /[a-z]/i;
